import {
  ApiGmwGeojsonList200ResponseFeaturesInnerProperties,
  ApiGmwGmwsListRequest,
  GMW,
} from "@nens/brostar/openapi-client";
import { qualityRegimeOptionsType, yesNoOptions } from "@nens/brostar/uploadapi-client";

import { SearchOption } from "@/components/searchbox";

export const gmwInformation: SearchOption<
  keyof GMW & keyof ApiGmwGeojsonList200ResponseFeaturesInnerProperties,
  keyof ApiGmwGmwsListRequest
>[] = [
  { key: "broId", searchKey: "broIdIcontains", label: "Bro-ID" },
  { key: "nitgCode", searchKey: "nitgCodeIcontains", label: "NITG-code" },
  {
    key: "wellConstructionDate",
    searchKey: "wellConstructionDateIcontains",
    label: "Inrichtingsdatum put",
  },
  {
    key: "qualityRegime",
    label: "Kwaliteitsregime",
    enum: qualityRegimeOptionsType.map((key) => ({ key, label: key })),
  },
  {
    key: "removed",
    label: "Verwijderd?",
    enum: yesNoOptions.map(({ value, label }) => ({ key: value, label })),
  },
];

export type GMWFiltersByGMN = {
  gmnIds?: string[];
  unlinkedChecked?: boolean;
};

export interface GMWSFilters extends GMWFiltersByGMN {
  search:
    | {
        searchString: string;
        searchField: keyof ApiGmwGmwsListRequest;
      }
    | undefined;
  page: number;
}

export type SelectedGmw = ApiGmwGeojsonList200ResponseFeaturesInnerProperties | undefined;
